import { useEffect } from "react";

interface Shortcuts {
	onNewChat?: () => void;
	onFocusInput?: () => void;
	onToggleSidebar?: () => void;
	onSendMessage?: () => void;
}

export function useKeyboardShortcuts(shortcuts: Shortcuts) {
	useEffect(() => {
		const handler = (e: KeyboardEvent) => {
			// Ignore if typing in an input/textarea
			const target = e.target as HTMLElement;
			if (target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable) {
				// Allow Cmd+Enter to send even when in textarea
				if (e.key === "Enter" && (e.metaKey || e.ctrlKey)) {
					e.preventDefault();
					shortcuts.onSendMessage?.();
				}
				return;
			}

			if (e.key === "k" && (e.metaKey || e.ctrlKey)) {
				e.preventDefault();
				shortcuts.onFocusInput?.();
			}

			if (e.key === "n" && (e.metaKey || e.ctrlKey)) {
				e.preventDefault();
				shortcuts.onNewChat?.();
			}

			if (e.key === "b" && (e.metaKey || e.ctrlKey)) {
				e.preventDefault();
				shortcuts.onToggleSidebar?.();
			}

			if (e.key === "Escape") {
				shortcuts.onToggleSidebar?.();
			}
		};

		window.addEventListener("keydown", handler);
		return () => window.removeEventListener("keydown", handler);
	}, [shortcuts]);
}
